import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ProtectedRouteType } from "../Interface/Index";
import { useAuth } from "../Context/AuthContext/Index";
import AuthService from "../Services/auth.service";

const ProtectedRoute: React.FC<ProtectedRouteType> = ({ children }) => {
  const navigate = useNavigate();
  const { isUserLoggedIn } = useAuth();
  const user = AuthService.getInstance().getCurrentUser();
  const location = useLocation();

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ location:", location);

    if (!user && (!location.pathname || !location.search)) {
      navigate("/");
    } else if (!user) {
      const path = location.pathname.startsWith("/")
        ? location.pathname
        : `/${location.pathname}`;
      const redirectUrl = encodeURIComponent(`${path}${location.search}`);
      navigate(`/sign-in?redirect_url=${redirectUrl}`);
    }
  }, [user, navigate, location]);

  return <>{isUserLoggedIn ? children : null}</>;
};

export default ProtectedRoute;
